const FloatingCTA = () => {
  return null;
};

export default FloatingCTA;
